import { useEffect, useState } from 'react';
import type { WhatsAppTemplateModalProps } from '../../../../types/templates/template-modal.types';
import { WhatsAppTemplateModalContent } from './template-modal-content';
import { StandaloneWhatsAppTemplateModal } from './standalone-template-modal';

/**
 * Opens the template form with a feature action or its standalone send hook.
 * @param props - Current feature state and consumer-owned callbacks.
 * @returns The corresponding composer surface.
 */
export const WhatsAppTemplateModal = ({
  isOpen,
  onSendTemplate,
  isSending,
  ...displayProps
}: WhatsAppTemplateModalProps) => {
  const [hasOpened, setHasOpened] = useState(isOpen);
  useEffect(() => {
    if (isOpen) setHasOpened(true);
  }, [isOpen]);
  if (!hasOpened && !isOpen) return null;
  if (onSendTemplate) {
    return (
      <WhatsAppTemplateModalContent
        {...displayProps}
        isOpen={isOpen}
        onSendTemplate={onSendTemplate}
        isSending={isSending}
      />
    );
  }
  return <StandaloneWhatsAppTemplateModal {...displayProps} isOpen={isOpen} />;
};
